import { Machine } from 'types/common/machine.type';
import DateTime from 'utils/dateTime/dateTime';
import { create } from 'zustand';

type MachineStoreProps = {
  machine: Machine | null;
  setMachine: (machine: Machine) => void;
  getClosedDays: () => string[];
};

const useMachineStore = create<MachineStoreProps>((set, get) => ({
  machine: null,
  setMachine(machine: Machine) {
    set({ machine });
  },
  getClosedDays() {
    const result = get()
      .machine?.point.closedDays.sort((a, b) => {
        return new Date(a).getTime() - new Date(b).getTime();
      })
      .map(day => new DateTime().convertDateYear(day));

    return result || [];
  },
}));

export default useMachineStore;
